import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Section } from "./section";

export function LayoutSection() {
	return (
		<>
			<Section title="Karty">
				<div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
					<Card>
						<CardHeader>
							<CardTitle>Karta podstawowa</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Zawartość karty. Używana do grupowania powiązanych treści.
							</p>
						</CardContent>
					</Card>
					<Card className="border-primary">
						<CardHeader>
							<CardTitle className="text-primary">
								Karta — primary border
							</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Obramowanie w kolorze primary dla wyróżnienia.
							</p>
						</CardContent>
					</Card>
					<Card className="bg-muted">
						<CardHeader>
							<CardTitle>Karta — muted bg</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Tło w kolorze muted — subtelne wyróżnienie.
							</p>
						</CardContent>
					</Card>
				</div>
			</Section>

			<Section title="Skeleton (ładowanie)">
				<Card>
					<CardContent className="pt-6 flex flex-col gap-3">
						<Skeleton className="h-5 w-48" />
						<Skeleton className="h-10 w-full" />
						<Skeleton className="h-10 w-full" />
						<Skeleton className="h-5 w-32" />
						<Skeleton className="h-10 w-3/4" />
					</CardContent>
				</Card>
			</Section>

			<Section title="Radius">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-wrap gap-4 items-end">
							<div className="flex flex-col gap-2 items-center">
								<div className="size-16 bg-primary rounded-none" />
								<p className="text-xs text-muted-foreground">rounded-none</p>
							</div>
							<div className="flex flex-col gap-2 items-center">
								<div className="size-16 bg-primary rounded-sm" />
								<p className="text-xs text-muted-foreground">rounded-sm</p>
							</div>
							<div className="flex flex-col gap-2 items-center">
								<div
									className="size-16 bg-primary"
									style={{ borderRadius: "var(--radius)" }}
								/>
								<p className="text-xs text-muted-foreground">--radius</p>
							</div>
							<div className="flex flex-col gap-2 items-center">
								<div className="size-16 bg-primary rounded-xl" />
								<p className="text-xs text-muted-foreground">rounded-xl</p>
							</div>
							<div className="flex flex-col gap-2 items-center">
								<div className="size-16 bg-primary rounded-full" />
								<p className="text-xs text-muted-foreground">rounded-full</p>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>
		</>
	);
}
